










import { computed, defineComponent, PropType } from '@vue/composition-api';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';

export default defineComponent({
  props: {
    mediaEntry: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },

  setup: function (props) {
    const showVideo = computed(() => !props.mediaEntry[0]?.includes('base64'));

    return {
      showVideo
    };
  },
});
